module.exports = __webpack_public_path__ + "static/media/bannerbig.00db2e51.jpg";